export default __webpack_public_path__ + "static/media/lfg-dbz.237ad878.jpeg";